import Head from 'next/head';

import * as C from './PageMeta.const';
import * as T from './PageMeta.types';

export const PageMeta = ({
  title,
  description,
  image,
  canonicalHref,
  disableIndexing,
}: T.MetaProps) => {
  return (
    <Head>
      <title>{title || C.defaultMeta.title}</title>

      {disableIndexing && <meta name="robots" content="noindex, nofollow" />}

      <meta
        name="description"
        content={description || C.defaultMeta.description}
        key="description"
      />

      <meta
        name="og:title"
        content={title || C.defaultMeta.title}
        key="og_title"
      />
      <meta
        name="og:description"
        content={description || C.defaultMeta.description}
        key="og_description"
      />

      <meta
        name="og:image"
        content={image || C.defaultMeta.image}
        key="og_image"
      />

      <link
        rel="canonical"
        href={canonicalHref || C.defaultMeta.canonicalHref}
      />
    </Head>
  );
};
